import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";
import 'reflect-metadata';
import {environment} from './environments/environment';

Sentry.init({
  dsn: "https://3b4029097e6f7eb6fe7b125597e4b4fe@o4510696873525248.ingest.de.sentry.io/4510697503522896",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  environment: environment.environment,
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
